import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';

import { useCarePlanService } from '@/shared/guard';
import { useFctReport } from '@/shared/hook';
import { isNotEmpty } from '@/shared/util';
import { useDefaultFindingStore, useFindingStore } from '@/store';

import { useUpfrontReportValidation } from '../../hook';
import { useCreateActivityLog } from './use-create-activity-log.hook';
import { useEvaluateLinks } from './use-evaluate-links.hook';

export function ReportingState() {
  const { links } = useCarePlanService();
  const evaluateLinks = useEvaluateLinks(links);

  useUpfrontReportValidation(links);

  const findings = useFindingStore((state) => state.findings);
  const defaultFindings = useDefaultFindingStore((state) => state.defaultFindings);

  const { report } = useFctReport();

  useCreateActivityLog(report);

  useEffect(() => {
    if (isNotEmpty(Object.keys(findings)) || links || isNotEmpty(Object.keys(defaultFindings))) {
      evaluateLinks();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [findings, links, defaultFindings]);

  return <Outlet />;
}
